export default __webpack_public_path__ + "static/logohvezdarna2-c097d3029156e68148b370726262f623.png";